import { render, staticRenderFns } from "./childSongs.vue?vue&type=template&id=b9b3382e&scoped=true"
import script from "./childSongs.vue?vue&type=script&lang=js"
export * from "./childSongs.vue?vue&type=script&lang=js"
import style0 from "./childSongs.vue?vue&type=style&index=0&id=b9b3382e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b3382e",
  null
  
)

export default component.exports